/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { InputAdornment, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 * Display a circle and a Tooltip on the provided direction
 * @param { string } title string.
 * @param { string } position for positioning the circle icon.
 * @param { string } tooltipPlacement for positioning the tooltip.
 */
const InputTooltip = ({ position, title, tooltipPlacement }) => {
	return (
		<InputAdornment position={position}>
			<Tooltip arrow interactive placement={tooltipPlacement} title={title}>
				<i style={{ height: "15px", color: "gray" }} className="fas fa-info-circle" />
			</Tooltip>
		</InputAdornment>
	);
};

InputTooltip.defaultProps = {
	position: "start",
	tooltipPlacement: "bottom-start",
};
InputTooltip.propTypes = {
	title: PropTypes.string.isRequired,
	position: PropTypes.oneOf(["start", "end"]),
	tooltipPlacement: PropTypes.oneOf([
		"bottom-end",
		"bottom-start",
		"bottom",
		"left-end",
		"left-start",
		"left",
		"right-end",
		"right-start",
		"right",
		"top-end",
		"top-start",
		"top",
	]),
};

export default InputTooltip;
